import { SHOW_CALENDAR_MODAL } from "./actionsTypes"

export function changeModalCalendarState(state) {
  return {
    type: SHOW_CALENDAR_MODAL,
    payload: state,
  }
}
